import * as orderEvents from './events/order';
import * as cartEvents from './events/cart';
import { visitCheckout, handleAddressCheck, getCheckoutEvents } from './events/checkout';
import * as userEvents from './events/user';
import * as ingredientsEvents from './events/ingredients';
import * as otherEvents from './events/other';
//
import * as cartTypes from '../modules/cart/actionTypes';
import * as locationTypes from '../modules/location';

const tryFunc = func => (...args) => {
  try {
    return func(...args);
  } catch ({ message }) {
    if (func) {
      console.warn(`[analytic] Error in ${func.name || '[funcName undefined]'}: ${message}`);
    } else {
      console.warn(`[analytic] Analytic function is not defined => message: ${message}`);
    }

    return null;
  }
};

const getCheckoutEventsWithTryFunc = type => getCheckoutEvents(type, tryFunc);

export default function eventsMapper(action) {
  switch (action.type) {
    /* === CHECKOUT events === */
    // Посещение корзины
    case locationTypes.LOCATION_CHANGE:
    case cartTypes.FETCH_ITEMS_SUCCESS:
      return action.payload?.withoutAnalytic // Если стоит флаг "Без аналитики" в payload, то возвращать null
        ? null
        : tryFunc(visitCheckout);

    // Смена типа оплаты/доставки
    case '@order/SET_CHECKOUT_PAY_TYPE':
    case '@order/SET_CHECKOUT_DELIVERY_TYPE':
      return getCheckoutEventsWithTryFunc(action.type);

    // Обработка ошибок адреса
    case '@order/FETCH_DELIVERY_RESTAURANT_DETAILS_SUCCESS':
    case '@order/FETCH_DELIVERY_RESTAURANT_DETAILS_FAILURE':
      return tryFunc(handleAddressCheck);

    /* === OTHER events === */
    // Смена языка
    case '@intl/LOCALE_CHANGE':
      return tryFunc(otherEvents.localeChange);

    // Смена города
    case '@city/SET_USER_CITY':
      return tryFunc(otherEvents.cityChange);

    /* === ORDER events === */
    // Успешная оплата
    case '@analytic/ORDER_SENDED':
      return getCheckoutEventsWithTryFunc(action.type);

    // Повтор заказа
    case '@order/ADD_TO_CART_SUCCESS':
      return tryFunc(orderEvents.repeatOrder);

    // Повтор заказа
    case '@catalog/ADD_TO_CART_FROM_UPSALE': {
      return tryFunc(cartEvents.addToCartFromUpsale);
    }

    /* === CART events === */
    // Добавление продукта в корзину
    case '@cart/ITEMS_UPDATE':
    case '@cart/UPDATE_ITEM_SUCCESS':
    case '@cart/ADD_TO_CART_SUCCESS':
      return action.payload.withoutAnalytic // Если стоит флаг "Без аналитики" в payload, то возвращать null
        ? null
        : [tryFunc(cartEvents.productClickSuccess), tryFunc(cartEvents.updateItemCountSuccess)];

    // Удаление товара из корзины
    case '@cart/REMOVE_ITEM_SUCCESS':
      return tryFunc(cartEvents.removeItemSuccess);
    // Очистка корзины
    case '@cart/CLEAR_SUCCESS':
      return tryFunc(cartEvents.clearCheckoutSuccess);

    /* === USER events === */
    // Авторизация
    case '@user/SIGNIN_SUCCESS':
      return tryFunc(userEvents.loginSuccess);

    // Регистрация
    case '@user/SIGNUP_SUCCESS':
      return tryFunc(userEvents.signUpSuccess);

    // Смена данных в профиле
    case '@user/UPDATE_PROFILE_SUCCESS':
      return tryFunc(userEvents.updateProfileSuccess);

    // Отправка кода подтверждения смены пароля
    case '@user/RECOVERY_PASSWORD_SEND_CONFIRM_CODE_SUCCESS':
      return tryFunc(userEvents.recoveryPasswordSendConfirmCodeSuccess);

    // Успешная смена пароля
    case '@user/RECOVERY_PASSWORD_SUCCESS':
      return tryFunc(userEvents.recoveryPasswordSuccess);

    // Отправка кода подтверждения смены телефона
    case '@user/RECOVERY_PHONE_CONFIRM_SMS_SUCCESS':
      return tryFunc(userEvents.recoveryPhoneSendConfirmSmsSuccess);

    case '@address/SAVE_ADDRESS_SUCCESS':
      return tryFunc(userEvents.saveAddressSuccess);

    /* === INGREDIENTS events === */
    // Изменение ингредиентов
    case '@constructor/ADD_PORTION':
    case '@constructor/REMOVE_PORTION':
    case '@constructor/REMOVE_INGREDIENT':
    case '@catalog/REMOVE_INGREDIENT':
      return tryFunc(ingredientsEvents.changeIngredients);

    // === STOCK events
    // Применение промокода
    case '@stock/APPLY_STOCK_SUCCESS':
    case '@stock/APPLY_STOCK_FAILURE':
      return tryFunc(otherEvents.applyStock);

    default:
      return [];
  }
}
